<template>
    <div>
      <div class="air__utils__heading">
        <div class="row">
          <div class="col-4 col-sm-6">
            <h5>Vehicles</h5>
          </div>
          <div class="col-8 col-sm-6 text-right">
            <div class="d-inline-flex flex-row">
              <!-- <div class="mr-2">
                <bulk-upload-vehicle />
              </div> -->
              <div class="mr-2">
                <new-vehicle @created="handleCreated"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" v-if="pagepermission.viewable">
        <div class="col-xl-12">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 mb-2" v-if="!selectedRowKeys.length">
              <a-input-search
                placeholder="Search Vehicle..."
                size="large"
                v-model="search"
                @search="searchVehicle"
              />
            </div>

            <div class="col-12 col-md-6 mb-2" v-if="!selectedRowKeys.length">
              <div class="row justify-content-around">
                <div class="col">
                  <a-input-search
                    placeholder="Search Driver..."
                    size="large"
                    v-model="search_driver"
                    @search="searchDriver"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-center" v-if="pagepermission.viewable">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <vehicle-table :data="data" :rolesetting="pagepermission" :loading="loading" @updateTable="handleUpdateTable" />
            </div>
          </div>
          <div class="text-right">
            <a-pagination
                showSizeChanger
                @showSizeChange="onShowSizeChange"
                :total="meta.total"
                :pageSize.sync="pageSize"
                v-model="current"
                @change="onChange"
              >
            </a-pagination>
          </div>
        </div>
      </div>
      <div class="row justify-content-center" v-else>
        <p class="error">
          You don't have permission to use this feature.
        </p>
      </div>
    </div>
  </template>

<script>
import VehicleTable from '@/components/transport/vehicle/index'
import NewVehicle from '@/components/transport/vehicle/new'
// import BulkUploadVehicle from '@/components/transport/vehicle/bulk/index'

import { debounce } from 'lodash'

export default {
  components: {
    VehicleTable,
    NewVehicle,
    // BulkUploadVehicle,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('inventory', 22)
    rc.then(data => {
      // console.log('RoleCheck!Data processed. ', data)
      this.pagepermission = data.pagePermission
    })
  },
  created() {
    this.searchVehicle = debounce(this.searchVehicle, 500)
  },
  mounted: function() {
    this.getVehicles()
    this.getClasses()
    this.getProductCategories()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      search: null,
      search_driver: null,
      selectedRowKeys: [],
      schoolClasses: [],
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      selectedClassId: undefined,
      selectedCategoryId: undefined,
      selectedSubCategoryId: undefined,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    handleTableSelect: function(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    getClasses: function() {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getProductCategories: function() {
      this.$http.get('/api/library/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function(selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_id === selectedCategoryId)
    },
    getVehicles: function(isSearch) {
      this.selectedRowKeys = []
      this.loading = true
      let page = this.current
      if (isSearch) {
        page = 1
        this.current = 1
      }
      this.$http.get('/api/transport/vehicle', {
        params: {
          // class_id: this.selectedClassId,
          // category_id: this.selectedCategoryId,
          // sub_category_id: this.selectedSubCategoryId,
          limit: this.pageSize,
          page: page,
          search: this.search,
          search_driver: this.search_driver,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchVehicle: function(value) {
      this.search = value
      this.getVehicles(true)
    },
    searchDriver: function(value) {
      this.search_driver = value
      this.getVehicles(true)
    },
    onChangeSearchProducts: function(e) {
      this.search = e.target.value
      this.getVehicles(true)
    },
    handleCreated: function() {
      this.getVehicles()
    },
    handleUpdateTable: function() {
      this.getVehicles()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getVehicles()
    },
    onChange(current) {
      this.current = current
      this.getVehicles()
    },
    handleClassSelect(selectedClassId) {
      this.getVehicles(true)
    },
    handleCategorySelect(selectedCategoryId) {
      this.getVehicles(true)
      this.getSubCategories(selectedCategoryId)
    },
    handleSubCategorySelect(selectedSubCategoryId) {
      this.getVehicles(true)
    },
  },
}
</script>
  <style>
  .error { padding: 25px 5px; }
  </style>
